"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.array.splice.js");

var _createForOfIteratorHelper2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js"));

var _classCallCheck2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/root/.jenkins/workspace/b9-web-exchange/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var EventDispatcher = /*#__PURE__*/function () {
  function EventDispatcher() {
    (0, _classCallCheck2.default)(this, EventDispatcher);
    this.maps = {};
  }

  (0, _createClass2.default)(EventDispatcher, [{
    key: "addEventListener",
    value: function addEventListener(type, listener, thisObject) {
      if (!this.maps[type]) {
        this.maps[type] = [];
      }

      var _iterator = (0, _createForOfIteratorHelper2.default)(this.maps[type]),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item.listener === listener && item.thisObject === thisObject) {
            return;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.maps[type].push({
        listener: listener,
        thisObject: thisObject
      });
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener, thisObject) {
      if (this.maps[type]) {
        var _iterator2 = (0, _createForOfIteratorHelper2.default)(this.maps[type]),
            _step2;

        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;

            if (item.listener === listener && item.thisObject === thisObject) {
              var idx = this.maps[type].indexOf(item);
              this.maps[type].splice(idx, 1);
              return;
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(type, data) {
      if (this.maps[type]) {
        var _iterator3 = (0, _createForOfIteratorHelper2.default)(this.maps[type]),
            _step3;

        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var item = _step3.value;
            item.listener.apply(item.thisObject, [data]);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
    }
  }]);
  return EventDispatcher;
}();

var Dispatcher = /*#__PURE__*/function () {
  function Dispatcher() {
    (0, _classCallCheck2.default)(this, Dispatcher);
  }

  (0, _createClass2.default)(Dispatcher, null, [{
    key: "addEventListener",
    value: function addEventListener(type, listener, thisObject) {
      this.eventDispatcher.addEventListener(type, listener, thisObject);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(type, listener, thisObject) {
      this.eventDispatcher.removeEventListener(type, listener, thisObject);
    }
  }, {
    key: "dispatchEvent",
    value: function dispatchEvent(type, data) {
      this.eventDispatcher.dispatchEvent(type, data);
    }
  }]);
  return Dispatcher;
}();

exports.default = Dispatcher;
Dispatcher.eventDispatcher = new EventDispatcher();